import React, { useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import { Card } from "antd";
import "./index.css";
import AddTech from "./addTech";
import RemoveTech from "./removeTech";
import {
  taskAssign,
  updateTechApi,
  deleteTechApi,
} from "../../../functions/technicians";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { loaderReducer } from "../../../components/toolkit/loader";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { Select, Space } from "antd";

const Index = ({
  arg: {
    activeEdit,
    setActiveEdit,
    handleActiveEdit,
    techAllDetails,
    setTechAllDetails,
    setRefreshData,
    openOrders,
    setOpenOrders,
    updateTech,
    setUpdateTech,
    setUpdateEmail,
    handleExitwithoutSaving,
  },
}) => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const token = cookies.get("token");
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const navigate = useNavigate();

  const fetchOpenOrders = async () => {
    dispatch(loaderReducer(true));
    try {
      if (techAllDetails._id) {
        await taskAssign(token, techAllDetails._id)
          .then((res) => {
            dispatch(loaderReducer(false));
            // console.log("fetchOpenOrders==>>", res);
            setOpenOrders(res.data.data.workOrders);
          })
          .catch((err) => {
            dispatch(loaderReducer(false));
            console.log(err);
            setOpenOrders([]);
          });
      }
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error);
      setOpenOrders([]);
    }
  };

  useEffect(() => {
    fetchOpenOrders();
  }, [techAllDetails._id]);

  // update tech api --------------------------------------------------------------
  const inputUpdateHandler = (e) => {
    setUpdateTech({ ...updateTech, [e.target.name]: e.target.value });
  };

  const updateData = async (e) => {
    e.preventDefault();
    dispatch(loaderReducer(true));
    try {
      if (techAllDetails._id) {
        const { password,techId, ...updatedDetails } = updateTech;

        await updateTechApi(token, techAllDetails._id, updatedDetails)
          .then((res) => {
            // console.log("res", res.data);
            dispatch(loaderReducer(false));
            toast.success(
              `You have successfully updated technician data ${res.data.update.name}`
            );
            setUpdateEmail(res.data.update.email);
            setActiveEdit(false);
          })
          .catch((err) => {
            console.log(err, "err");
            dispatch(loaderReducer(false));
            toast.error(err.message);
            setActiveEdit(false);
          });
      }
    } catch (error) {
      dispatch(loaderReducer(false));
      toast.error(error);
    }
  };

  //Delete tech api ----------------------------------------------

  const handleDeletebutton = async (e) => {
    setConfirmLoading(true);
    // e.preventDefault();
    try {
      if (techAllDetails._id) {
        await deleteTechApi(token, techAllDetails._id)
          .then((res) => {
            setOpen(false);
            setConfirmLoading(false);
            setUpdateEmail(res.data.deleted.email);
            setActiveEdit(false);
            toast.success(
              `You have successfully deleted technician data ${res.data.deleted.name}`
            );
          })
          .catch((err) => {
            console.log(err);
            setOpen(false);
            setConfirmLoading(false);
            setActiveEdit(false);
            err.response.status === 404
              ? toast.error("No Technicians found")
              : toast.error("Geeting some issue, try again");
          });
      }
    } catch (error) {
      toast.error(error);
      setConfirmLoading(false);
    }
  };

  //-------------------------------------------------------------------------
  const handleChange = (value) => {
    setUpdateTech((prevUpdateTech) => ({
      ...prevUpdateTech,
      role: value,
    }));
  };


  return (
    <div>
      {!activeEdit && (
        <div className="editbtn" onClick={handleActiveEdit}>
          Edit Technician’s Profile
        </div>
      )}
      <div className="tupdate mt-4">Details</div>
      <div>
        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Name</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <input
              type="text"
              name="name"
              className="form-control"
              value={updateTech.name}
              disabled={!activeEdit}
              onChange={(e) => inputUpdateHandler(e)}
            />
            {activeEdit && (
              <div className="position-absolute end-0 top-0 pt-4">
                <BsPencil className="icon_dis" />
              </div>
            )}
          </div>
        </div>
        <div className="row mt-2">
          <div className="row position-relative">
            <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Tech ID</div>
            <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
              <input
                type="text"
                className={`form-control`}
                name="techId"
                value={updateTech.techId}
                disabled
                onChange={(e) => inputUpdateHandler(e)}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">EMAIL</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <input
              type="email"
              className="form-control"
              name="email"
              value={updateTech.email}
              disabled={!activeEdit}
              onChange={(e) => inputUpdateHandler(e)}
            />
            {activeEdit && (
              <div className="position-absolute end-0 top-0 pt-4">
                <BsPencil className="icon_dis" />
              </div>
            )}
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Password</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            <input
              type="password"
              name="password"
              className="form-control"
              value={updateTech.password}
              // disabled={!activeEdit}
              disabled
              onChange={(e) => inputUpdateHandler(e)}
            />
            {/*{activeEdit && (
              <div className="position-absolute end-0 top-0 pt-4">
                <BsPencil className="icon_dis" />
              </div>
            )} */}
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-2 col-md-4 col-sm-12 sub2head">User Type</div>
          <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
            {/* <input
              type="dropdown"
              name="password"
              className="form-control"
              value={updateTech.password}
              disabled={!activeEdit}
              onChange={(e) => inputUpdateHandler(e)}
            /> */}
            <Select
              value={updateTech?.role || "No role assigned"}
              style={{ width: "100%" }}
              className="mt-1"
              disabled={!activeEdit}
              onChange={handleChange}
              name="role"
              options={[
                {
                  value: "tech",
                  label: "Tech",
                  name: "role",
                },
                {
                  value: "user",
                  label: "User",
                  name: "role",
                },
              ]}
            />
            {activeEdit && (
              <div className="position-absolute end-0 top-0 pt-4">
                <BsPencil className="icon_dis" />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Open Orders */}

      <div className="tupdate mt-4">Open Orders</div>

      {openOrders?.length === 0 ? (
        <div>No Open Orders</div>
      ) : (
        openOrders &&
        openOrders.map((d, i) => (
          // <Link
          //   to={`/work-order?orderId=${d.tranId}`}
          //   style={{
          //     textDecoration: "none",
          //   }}
          // >
          <Card
            hoverable
            className="cardcls mt-2"
            key={i}
            onClick={() => {
              if (d.tranId) {
                navigate("/work-order", {
                  state: { tranId: d.tranId },
                });
              } else {
                console.error("formData or formData.tranId is undefined");
              }
            }}
          >
            <div className="d-flex gap-2">
              <div
                className="prioritytech"
                style={{
                  backgroundColor:
                    d.priority === "Medium"
                      ? "rgb(28, 68, 156)"
                      : d.priority === "Urgent"
                      ? "rgb(139, 0, 0)"
                      : d.priority === "High"
                      ? "rgb(255, 0, 0)"
                      : "#414C60",
                }}
              >
                PRIORITY: {d.priority}
              </div>
              <div
                className="prioritytech"
                style={{
                  backgroundColor:
                    d.apptStatus === "confirmed"
                      ? "#414c60"
                      : d.apptStatus === "pending"
                      ? "#FFB23E"
                      : "#5471a7",
                  color: d.apptStatus === "pending" ? "black" : "#fff",
                }}
              >
                STATUS: {d.apptStatus}
              </div>
            </div>
            <div className="d-flex mt-3 justify-content-between orderDateCss">
              <div className="">Order #{d.tranId}</div>
              <div style={{ color: "#1C449C" }}>
                {d.apptDate === ""
                  ? ""
                  : d.apptDate === "Invalid date"
                  ? ""
                  : new Date(d.apptDate).toLocaleDateString("en-US", {
                      month: "short", // Display the abbreviated month name
                      day: "numeric", // Display the day of the month
                      year: "numeric", // Display the year
                    })}
              </div>
            </div>
            <div className="mt-2">{d.specialInstructions}</div>
          </Card>
          // </Link>
        ))
      )}

      {/* -----button----- */}
      {!activeEdit && (
        <div className="mt-4 d-flex gap-2 justify-content-end">
          <AddTech arg={{ setRefreshData }} />
        </div>
      )}
      {activeEdit && (
        <div>
          <div className="mt-4 d-flex gap-2 justify-content-end">
            <RemoveTech
              arg={{
                handleDeletebutton,
                open,
                setOpen,
                confirmLoading,
                setConfirmLoading,
              }}
            />
          </div>
          <div className="d-flex mt-4 gap-2 justify-content-end">
            <div className="contd" onClick={handleExitwithoutSaving}>
              Exit without Saving
            </div>
            <div
              className="contd"
              style={{ backgroundColor: "#1C449C", color: "white" }}
              onClick={(e) => updateData(e)}
            >
              Save Changes
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
// onClick={(e) => handleExitwithoutSaving(e)}
